// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const FilterType = {
    FILTER_TYPE_INVALID: 'FILTER_TYPE_INVALID',
    FILTER_TYPE_STRING: 'FILTER_TYPE_STRING',
    FILTER_TYPE_INTEGER: 'FILTER_TYPE_INTEGER',
    FILTER_TYPE_DATE: 'FILTER_TYPE_DATE',
    FILTER_TYPE_FLOAT: 'FILTER_TYPE_FLOAT',
    FILTER_TYPE_BOOLEAN: 'FILTER_TYPE_BOOLEAN',
    FILTER_TYPE_TAG: 'FILTER_TYPE_TAG',
    FILTER_TYPE_PHONE: 'FILTER_TYPE_PHONE',
};
export const FilterTypeValue = {
    FILTER_TYPE_INVALID: 0,
    FILTER_TYPE_STRING: 1,
    FILTER_TYPE_INTEGER: 2,
    FILTER_TYPE_DATE: 3,
    FILTER_TYPE_FLOAT: 4,
    FILTER_TYPE_BOOLEAN: 5,
    FILTER_TYPE_TAG: 6,
    FILTER_TYPE_PHONE: 8,
};
export const FilterOperator = {
    FILTER_OPERATOR_INVALID: 'FILTER_OPERATOR_INVALID',
    FILTER_OPERATOR_IS_EMPTY: 'FILTER_OPERATOR_IS_EMPTY',
    FILTER_OPERATOR_IS_NOT_EMPTY: 'FILTER_OPERATOR_IS_NOT_EMPTY',
    FILTER_OPERATOR_IS: 'FILTER_OPERATOR_IS',
    FILTER_OPERATOR_IS_NOT: 'FILTER_OPERATOR_IS_NOT',
    FILTER_OPERATOR_IS_ANY: 'FILTER_OPERATOR_IS_ANY',
    FILTER_OPERATOR_IS_NOT_ANY: 'FILTER_OPERATOR_IS_NOT_ANY',
    FILTER_OPERATOR_IS_ALL: 'FILTER_OPERATOR_IS_ALL',
    FILTER_OPERATOR_IS_NOT_ALL: 'FILTER_OPERATOR_IS_NOT_ALL',
    FILTER_OPERATOR_CONTAINS: 'FILTER_OPERATOR_CONTAINS',
    FILTER_OPERATOR_DOES_NOT_CONTAIN: 'FILTER_OPERATOR_DOES_NOT_CONTAIN',
    FILTER_OPERATOR_IS_EQUAL_TO: 'FILTER_OPERATOR_IS_EQUAL_TO',
    FILTER_OPERATOR_IS_NOT_EQUAL_TO: 'FILTER_OPERATOR_IS_NOT_EQUAL_TO',
    FILTER_OPERATOR_IS_GREATER_THAN: 'FILTER_OPERATOR_IS_GREATER_THAN',
    FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO: 'FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO',
    FILTER_OPERATOR_IS_LESS_THAN: 'FILTER_OPERATOR_IS_LESS_THAN',
    FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO: 'FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO',
    FILTER_OPERATOR_IS_BEFORE: 'FILTER_OPERATOR_IS_BEFORE',
    FILTER_OPERATOR_IS_BEFORE_OR_ON: 'FILTER_OPERATOR_IS_BEFORE_OR_ON',
    FILTER_OPERATOR_IS_AFTER: 'FILTER_OPERATOR_IS_AFTER',
    FILTER_OPERATOR_IS_AFTER_OR_ON: 'FILTER_OPERATOR_IS_AFTER_OR_ON',
    FILTER_OPERATOR_IS_BETWEEN: 'FILTER_OPERATOR_IS_BETWEEN',
    FILTER_OPERATOR_IS_NOT_BETWEEN: 'FILTER_OPERATOR_IS_NOT_BETWEEN',
    FILTER_OPERATOR_IS_VALID: 'FILTER_OPERATOR_IS_VALID',
    FILTER_OPERATOR_IS_NOT_VALID: 'FILTER_OPERATOR_IS_NOT_VALID',
    FILTER_OPERATOR_ANNIVERSARY_IS: 'FILTER_OPERATOR_ANNIVERSARY_IS',
};
export const FilterOperatorValue = {
    FILTER_OPERATOR_INVALID: 0,
    FILTER_OPERATOR_IS_EMPTY: 1,
    FILTER_OPERATOR_IS_NOT_EMPTY: 2,
    FILTER_OPERATOR_IS: 3,
    FILTER_OPERATOR_IS_NOT: 4,
    FILTER_OPERATOR_IS_ANY: 5,
    FILTER_OPERATOR_IS_NOT_ANY: 6,
    FILTER_OPERATOR_IS_ALL: 7,
    FILTER_OPERATOR_IS_NOT_ALL: 8,
    FILTER_OPERATOR_CONTAINS: 9,
    FILTER_OPERATOR_DOES_NOT_CONTAIN: 10,
    FILTER_OPERATOR_IS_EQUAL_TO: 11,
    FILTER_OPERATOR_IS_NOT_EQUAL_TO: 12,
    FILTER_OPERATOR_IS_GREATER_THAN: 13,
    FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO: 14,
    FILTER_OPERATOR_IS_LESS_THAN: 15,
    FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO: 16,
    FILTER_OPERATOR_IS_BEFORE: 17,
    FILTER_OPERATOR_IS_BEFORE_OR_ON: 18,
    FILTER_OPERATOR_IS_AFTER: 19,
    FILTER_OPERATOR_IS_AFTER_OR_ON: 20,
    FILTER_OPERATOR_IS_BETWEEN: 21,
    FILTER_OPERATOR_IS_NOT_BETWEEN: 22,
    FILTER_OPERATOR_IS_VALID: 23,
    FILTER_OPERATOR_IS_NOT_VALID: 24,
    FILTER_OPERATOR_ANNIVERSARY_IS: 25,
};
export const DateDefault = {
    DATE_DEFAULT_INVALID: 'DATE_DEFAULT_INVALID',
    DATE_DEFAULT_TODAY: 'DATE_DEFAULT_TODAY',
    DATE_DEFAULT_YESTERDAY: 'DATE_DEFAULT_YESTERDAY',
    DATE_DEFAULT_TOMORROW: 'DATE_DEFAULT_TOMORROW',
    DATE_DEFAULT_THIS_WEEK: 'DATE_DEFAULT_THIS_WEEK',
    DATE_DEFAULT_LAST_WEEK: 'DATE_DEFAULT_LAST_WEEK',
    DATE_DEFAULT_NEXT_WEEK: 'DATE_DEFAULT_NEXT_WEEK',
    DATE_DEFAULT_THIS_MONTH: 'DATE_DEFAULT_THIS_MONTH',
    DATE_DEFAULT_LAST_MONTH: 'DATE_DEFAULT_LAST_MONTH',
    DATE_DEFAULT_NEXT_MONTH: 'DATE_DEFAULT_NEXT_MONTH',
    DATE_DEFAULT_THIS_QUARTER: 'DATE_DEFAULT_THIS_QUARTER',
    DATE_DEFAULT_LAST_QUARTER: 'DATE_DEFAULT_LAST_QUARTER',
    DATE_DEFAULT_NEXT_QUARTER: 'DATE_DEFAULT_NEXT_QUARTER',
    DATE_DEFAULT_THIS_YEAR: 'DATE_DEFAULT_THIS_YEAR',
    DATE_DEFAULT_LAST_YEAR: 'DATE_DEFAULT_LAST_YEAR',
    DATE_DEFAULT_NEXT_YEAR: 'DATE_DEFAULT_NEXT_YEAR',
};
export const DateDefaultValue = {
    DATE_DEFAULT_INVALID: 0,
    DATE_DEFAULT_TODAY: 1,
    DATE_DEFAULT_YESTERDAY: 2,
    DATE_DEFAULT_TOMORROW: 3,
    DATE_DEFAULT_THIS_WEEK: 4,
    DATE_DEFAULT_LAST_WEEK: 5,
    DATE_DEFAULT_NEXT_WEEK: 6,
    DATE_DEFAULT_THIS_MONTH: 7,
    DATE_DEFAULT_LAST_MONTH: 8,
    DATE_DEFAULT_NEXT_MONTH: 9,
    DATE_DEFAULT_THIS_QUARTER: 10,
    DATE_DEFAULT_LAST_QUARTER: 11,
    DATE_DEFAULT_NEXT_QUARTER: 12,
    DATE_DEFAULT_THIS_YEAR: 13,
    DATE_DEFAULT_LAST_YEAR: 14,
    DATE_DEFAULT_NEXT_YEAR: 15,
};
export const FilterGroupOperator = {
    FILTER_GROUP_OPERATOR_INVALID: 'FILTER_GROUP_OPERATOR_INVALID',
    FILTER_GROUP_OPERATOR_AND: 'FILTER_GROUP_OPERATOR_AND',
    FILTER_GROUP_OPERATOR_OR: 'FILTER_GROUP_OPERATOR_OR',
};
export const FilterGroupOperatorValue = {
    FILTER_GROUP_OPERATOR_INVALID: 0,
    FILTER_GROUP_OPERATOR_AND: 1,
    FILTER_GROUP_OPERATOR_OR: 2,
};
